import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS = createFcmConfig('revenue_subs_one_time_contributions', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
